import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { findUserOrders } from "../../redux/action/userActions";
import { getLocalStorage } from "../../utils/localStorage";
import { DataGrid } from '@mui/x-data-grid';
import { Box } from "@mui/material";
import clsx from 'clsx';
import { getOrderFile } from "../../redux/action/userActions";
import { Button } from "@material-ui/core";
import { useTitle } from "../../context/TitleProvider";
export const Orders = () => {
    const {setTitle} = useTitle()
    setTitle("Orders")
    const clientId = getLocalStorage("user").clientId;
    const [order, setOrder]  = useState([]);
    const dispatch = useDispatch();
    useEffect($ =>{
          dispatch(findUserOrders(clientId, setOrder)) ;
    }, [ dispatch, clientId])
    const downloadCsvFile = $ =>{
        dispatch(getOrderFile(clientId))
        
   }
   

    const columns = [
        {
            field: 'date',
            headerName: 'Date',
            width: 110,
        },
        {
            field: 'type',
            headerName: 'Type',
            width: 110,
        },
        {
            field: 'instrument',
            headerName: 'Instrument',
            width: 110,
        },
        {
            field: 'price',
            headerName: 'Price',
            width: 110,
        },
        {
             field: 'quantity',
            headerName: 'Quantity',
            width: 110,
        },
        {
            field: 'status',
           headerName: 'Status',
           width: 110,
           cellClassName: (params) =>
           clsx('super-app', {
              failed: params.value === "failed",
              completed: params.value ==="completed"
           }),
       },
       {
        field: 'message',
       headerName: 'Message',
       width: 200,
   },
      
    ]

    return <>
       <Box
        sx={{
            height: 500, width: '1',
            '& .super-app.failed': {
                color: 'red',
            },
            '& .super-app.completed': {
                color: 'green',
            },
        }}
    >
        <DataGrid
            columns={columns}
            rows={order}
            rowHeight={70}
            getRowId={(row) => row._id}
        />
    </Box>
    <Button  variant="contained"
color="default" onClick={downloadCsvFile}>Download csv file </Button>
    </>
}
